/**
 * Point d'entrée — monte React, enregistre le SW PWA.
 */
import React from 'react';
import ReactDOM from 'react-dom/client';
import { App } from './App';
import './styles.css';

// Enregistrement du service worker (autoUpdate via vite-plugin-pwa)
if ('serviceWorker' in navigator) {
  // Le plugin injecte l'auto-registration, on ne double pas ici.
}

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);
